import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import {
  covertToDropDownArray,
  FetchRequestHandler,
} from "../../utils/commonUtilities";
import { baseUrl } from "../../constants/Endpoints/EndPoints";

export const fetchExpEducationList = createAsyncThunk(
  "fetchExpEducationList",
  async (providerId) => {
    const result = await FetchRequestHandler("get",  `${baseUrl}api/providers/${providerId}/educations`);
    return result;
  }
);

export const fetchProviderEduType = createAsyncThunk(
  "fetchProviderEduType",
  async () => {
    const useMock = true;

    const providerEduType = [
      {
        id: 1,
        value: "Undergraduate Degree",
        metadata: { name: "Undergraduate Degree", type: "undergraduate" },
      },
      {
        id: 2,
        value: "Dental/Medical Degree",
        metadata: { name: "Dental/Medical Degree", type: "dental" },
      },
      {
        id: 3,
        value: "Other Graduate/Post Graduate Degree",
        metadata: {
          name: "Other Graduate/Post Graduate Degree",
          type: "graduate",
        },
      },
      {
        id: 3,
        value: "Advanced Education/Training",
        metadata: { name: "Advanced Education/Training", type: "advanced" },
      },
    ];

    if (useMock) {
      return new Promise((resolve) => {
        setTimeout(() => resolve(providerEduType), 500);
      });
    } else {
      const response = await axios.get("https://api.example.com/speciality");
      return response.data;
    }
  }
);

export const fetchUnderGraduateOptions = createAsyncThunk(
  "fetchUnderGraduateOptions",
  async () => {
    const useMock = true;

    const undergraduate = {
      degreeTypeResponseDTO: [
        {
          name: "AA",
          description: "Associate of Arts",
          type: "undergraduate",
        },
        {
          name: "AS",
          description: "Associate of Science",
          type: "undergraduate",
        },
        {
          name: "BA",
          description: "Bachelor of Arts",
          type: "undergraduate",
        },
        {
          name: "BS",
          description: "Bachelor of Science",
          type: "undergraduate",
        },
      ],
    };

    const convertedData = covertToDropDownArray(
      undergraduate.degreeTypeResponseDTO
    );

    if (useMock) {
      return new Promise((resolve) => {
        setTimeout(() => resolve(convertedData), 500);
      });
    } else {
      const response = await axios.get("https://api.example.com/speciality");
      return response.data;
    }
  }
);

export const fetchInstitutionList = createAsyncThunk(
  "fetchInstitutionList",
  async (res) => {
    const result = await FetchRequestHandler(
      "get",
      `${baseUrl}api/institutions?view=search&query=${res}`
    );

    return result;
  }
);

export const fetchDentalMedicalOptions = createAsyncThunk(
  "fetchDentalMedicalOptions",
  async () => {
    const useMock = true;

    const dentalandmedical = {
      degreeTypeResponseDTO: [
        {
          name: "MD",
          description: "Doctor of Medicine",
          type: "dental",
        },
        {
          name: "DDS",
          description: "Doctor of Dental Surgery",
          type: "dental",
        },
        {
          name: "DMD",
          description: "Doctor of Dental Medicine",
          type: "dental",
        },
        {
          name: "DD",
          description: "Doctor of Dentistry",
          type: "dental",
        },
        {
          name: "MDS",
          description: "Master of Dental Surgery",
          type: "dental",
        },
        {
          name: "MDSc",
          description: "Master of Dental Science",
          type: "dental",
        },
        {
          name: "MSD",
          description: "Master of Science in Dentistry",
          type: "dental",
        },
      ],
    };

    const convertedData = covertToDropDownArray(
      dentalandmedical.degreeTypeResponseDTO
    );

    if (useMock) {
      return new Promise((resolve) => {
        setTimeout(() => resolve(convertedData), 500);
      });
    } else {
      const response = await axios.get("https://api.example.com/speciality");
      return response.data;
    }
  }
);

export const fetchAdvancedEducationOptions = createAsyncThunk(
  "fetchAdvancedEducationOptions",
  async () => {
    const useMock = true;

    const advanced = {
      degreeTypeResponseDTO: [
        {
          name: "OPT",
          description: "Optional Practical Training",
          type: "advanced",
        },
        {
          name: "AEGD",
          description: "Advanced Education in General Dentistry",
          type: "advanced",
        },
        {
          name: "Residency",
          type: "advanced",
        },
        {
          name: "Fellowship",
          type: "advanced",
        },
      ],
    };

    const convertedData = covertToDropDownArray(advanced.degreeTypeResponseDTO);
    if (useMock) {
      return new Promise((resolve) => {
        setTimeout(() => resolve(convertedData), 500);
      });
    } else {
      const response = await axios.get("https://api.example.com/speciality");
      return response.data;
    }
  }
);

export const fetchOtherGraduteOptions = createAsyncThunk(
  "fetchOtherGraduteOptions",
  async () => {
    const useMock = true;

    const otherGraduate = {
      degreeTypeResponseDTO: [
        {
          name: "MA",
          description: "Master of Arts",
          type: "graduate",
        },
        {
          name: "MS",
          description: "Master of Science",
          type: "graduate",
        },
        {
          name: "MBA",
          description: "Master of Business Administration",
          type: "graduate",
        },
        {
          name: "MPH",
          description: "Master of Public Health",
          type: "graduate",
        },
        {
          name: "JD",
          description: "Juris Doctor",
          type: "graduate",
        },
        {
          name: "PHD",
          description: "Doctor of Philosophy",
          type: "graduate",
        },
        {
          name: "CAGS",
          description: "Certificate of Advanced Graduate Study",
          type: "graduate",
        },
      ],
    };

    const convertedData = covertToDropDownArray(
      otherGraduate.degreeTypeResponseDTO
    );
    if (useMock) {
      return new Promise((resolve) => {
        setTimeout(() => resolve(convertedData), 500);
      });
    } else {
      const response = await axios.get("https://api.example.com/speciality");
      return response.data;
    }
  }
);

export const fetchUpdateEducationList = createAsyncThunk(
  "fetchUpdateEducationList",
  async ({ payload, providerId, displayId }) => {
    console.log({ payload, providerId, displayId });

    const result = await FetchRequestHandler(
      "put",
      `${baseUrl}api/providers/${providerId}/educations/${displayId}`,
      payload
    );
    console.log({ result });

    return result;
  }
);

export const fetchSearchQuery = createAsyncThunk(
  "fetchSearchQuery",
  async (search) => {
    console.log({ search });

    const result = await FetchRequestHandler(
      "get",
      `${baseUrl}api/institutions?view=search&query=${encodeURIComponent(
        search
      )}`
    );
    return result;
  }
);

export const fetchDeleteEducation = createAsyncThunk(
  "fetchDeleteEducation",
  async ({ providerId, displayId }) => {
    const result = await FetchRequestHandler(
      "delete",
      `${baseUrl}api/providers/${providerId}/educations/${displayId}`
    );
    return result;
  }
);

export const fetchAddExpEducationData = createAsyncThunk(
  "fetchAddExpEducationData",
  async ({providerId, data}) => {
    const result = await FetchRequestHandler(
      "post",
      `${baseUrl}api/providers/${providerId}/educations`,
      data
    );
    return result;
  }
);

export const fetchRemoveLicenseItem = createAsyncThunk(
  "fetchRemoveLicenseItem",
  async ({providerId, licenseId}) => {
    const result = await FetchRequestHandler(
      "DELETE",
      `${baseUrl}api/providers/${providerId}/educations/${licenseId}`
      // `${baseUrl}api/providers/XTRCSYLJ91166157/educations`,
    );
    return result;
  }
);
